import React from "react";

export type CommercialListMetricTone =
  | "primary"
  | "success"
  | "danger"
  | "warning";

export interface CommercialListMetric {
  key: string;
  label: string;
  value: React.ReactNode;
  icon: React.ReactNode;
  tone: CommercialListMetricTone;
  description?: string;
}

interface CommercialListSummaryProps {
  ariaLabel: string;
  metrics: CommercialListMetric[];
}

const CommercialListSummary: React.FC<CommercialListSummaryProps> = ({
  ariaLabel,
  metrics,
}) => (
  <section className="commercial-list-summary" aria-label={ariaLabel}>
    {metrics.map((metric) => (
      <div
        className={`commercial-list-summary__metric commercial-list-summary__metric--${metric.tone}`}
        key={metric.key}
        title={metric.description}
      >
        <span className="commercial-list-summary__icon" aria-hidden="true">
          {metric.icon}
        </span>
        <span className="commercial-list-summary__content">
          <span className="commercial-list-summary__label">{metric.label}</span>
          <strong className="commercial-list-summary__value">
            {metric.value}
          </strong>
        </span>
      </div>
    ))}
  </section>
);

export default CommercialListSummary;
